import { Preview } from "@creatomate/preview";
import { Subtitle } from "chq";
import { errorService } from "app/utils";
import readVttSections from "./readVttSections";

type LoadSubtitles = {
  subtitles: Subtitle[];
  organizationName: string;
  preview: Preview;
}

const loadOldVttSubtitles = async ({
  subtitles,
  organizationName,
  preview
}: LoadSubtitles): Promise<void> => {
  await Promise.all(subtitles.map(subtitle => fetch(subtitle.url)))
    .then(async responses => {
      for (let index = 0; index < responses.length; index += 1) {
        const subtitle = subtitles[index];
        if (responses[index].ok) {
          // eslint-disable-next-line no-await-in-loop
          const text = await responses[index].text();
          // eslint-disable-next-line no-await-in-loop
          await readVttSections(
            { ...subtitle, text },
            subtitle.default,
            preview,
            organizationName,
            subtitle.language
          );
        } else {
          // Response failed, handle error
          errorService.error(`VTT file ${index + 1} failed to load with status ${responses[index].status}`);
        }
      }
    })
    .catch(error => {
      // Handle fetch error
      errorService.error(`Error fetching VTT files: ${error}`);
    });
};

export default loadOldVttSubtitles;
